import { API_ROUTE_ADMIN_TELE_POLICY_TEMPLATES } from '@/resources/api-routes'
import { get } from '@/util/auth'

import type { TelePolicyTemplateTypeOriginal } from './type'

const IS_NEW_BACKEND_API = true

export const getTelePolicyTemplatesList = async () => {
  const costObjects = await get<{ telePolicyTemplates: TelePolicyTemplateTypeOriginal[] }>(
    API_ROUTE_ADMIN_TELE_POLICY_TEMPLATES,
    IS_NEW_BACKEND_API
  )

  return costObjects.telePolicyTemplates
}
